import { render } from "./PushNotificationView.vue?vue&type=template&id=6a7df705&scoped=true"
import script from "./PushNotificationView.vue?vue&type=script&lang=js"
export * from "./PushNotificationView.vue?vue&type=script&lang=js"

import "./PushNotificationView.vue?vue&type=style&index=0&id=6a7df705&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7df705"]])

export default __exports__